import ReactMarkdown from 'react-markdown/react-markdown.min'

type Props = {
  content: string
}

export const ServerMarkdown = ({ content }: Props): JSX.Element => (
  <ReactMarkdown skipHtml={true}>{content}</ReactMarkdown>
)
